/* eslint-disable */
import React, { useState, useEffect, useLayoutEffect, Suspense } from 'react'
import Modal from 'react-modal'
import AST from '../YapDesigner/YapUI/YapUIAST.js'

// Import YapContentBuilder components
import { 
    YapContextMenu,
    YapContextMenuOption,
    YapHeaderButton,
    SegmentedControl,
    YapContextMenuDivider,
    YapContextMenuHeader
  } from '@yapstudios/yap-content-builder'


// Styling
import styled from 'styled-components'
import { ItemType } from './YapDesigner.js'

export function EditorDetail({ renderer, astPreview , jsPreview, componentInfo, inspectorPreview, editor, showOptions = true , optionsBottom = false }) {
    const { previewStates, previewIndex, setPreviewIndex, selectedItem, frameIdenfifier, items, setItems, allItems, selectedId, defaultFrame, setShowPreviewModal, showPreviewModal, setPreviewDisplayType, previewDisplayType, isComposerFrame } = editor 
    
    //const [displayType, setDisplayType] = useState("preview")

    /**
     * Reset state on selected item change
     */
    useLayoutEffect(() => {
        setPreviewIndex(null)
    }, [selectedId])

    /**
     * Options
     */
    const displayOptions = ["Preview"]//, "Info"]
    const displayOptionsKeys = ["preview"]//, "info"]

    if (componentInfo) {
        displayOptions.push("Metadata")
        displayOptionsKeys.push("info")
    }
    
    if (inspectorPreview) {
        displayOptions.push("Inspector")
        displayOptionsKeys.push("inspector")
    }

    if (isComposerFrame) {
        displayOptions.push("Composer")   
        displayOptionsKeys.push("composer") 
    }

    //displayOptions.push("AST") 
    //displayOptionsKeys.push("json") 

    const displayOption = displayOptions.length > 1 ? (
        <SegmentedControl options={displayOptions} keys={displayOptionsKeys} value={previewDisplayType} onChange={(value) => {
            //setDisplayType(value)
            setPreviewDisplayType(value)
        }}/>    
    ) : null


    /**
     * Construct Preview Panel Contnet
     */
    var previewContent = null
    switch (previewDisplayType) {
        case "preview":
            previewContent = renderer
            break;
        case "composer":
            previewContent = renderer
            break;
        case "json":
            previewContent = jsonPreview
            break
        case "info":
            previewContent = componentInfo
            break
        case "inspector":
            previewContent = inspectorPreview
            break
        case "js":
            previewContent = jsPreview
            break    
    }

    /**
     * Frame type options UI
     */
    const frameMenu = <FrameOptions frameIdenfifier={frameIdenfifier} setItems={setItems} items={items} allItems={allItems} selectedId={selectedId} defaultFrame={defaultFrame}/>

    /**
     * Preview Options
     */
    const stateOptionsMenu = <PreviewOptions previewStates={previewStates} previewIndex={previewIndex} setPreviewIndex={setPreviewIndex} />

    const previewFullscreenAction = (
        <div className="action" onClick={ () => { setShowPreviewModal(true) } }>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="#b1b1b1" d="M1.0332 4.91992C0.876953 4.91992 0.748047 4.86719 0.646484 4.76172C0.544922 4.65625 0.494141 4.52734 0.494141 4.375V1.12305C0.494141 0.826172 0.576172 0.595703 0.740234 0.431641C0.908203 0.263672 1.14062 0.179688 1.4375 0.179688H4.68945C4.84961 0.179688 4.98047 0.230469 5.08203 0.332031C5.1875 0.433594 5.24023 0.5625 5.24023 0.71875C5.24023 0.875 5.1875 1.00391 5.08203 1.10547C4.97656 1.20313 4.8457 1.25195 4.68945 1.25195H4.20312L2.15234 1.13477L3.77539 2.67578L5.58594 4.48047C5.63672 4.53125 5.67578 4.5918 5.70312 4.66211C5.73047 4.73242 5.74414 4.80664 5.74414 4.88477C5.74414 5.04883 5.68945 5.18164 5.58008 5.2832C5.4707 5.38086 5.33203 5.42969 5.16406 5.42969C5.01562 5.42969 4.89258 5.37891 4.79492 5.27734L2.99023 3.46094L1.44922 1.83789L1.56641 3.88281V4.375C1.56641 4.53125 1.51562 4.66211 1.41406 4.76758C1.31641 4.86914 1.18945 4.91992 1.0332 4.91992ZM7.46094 11.3594C7.30469 11.3594 7.17383 11.3086 7.06836 11.207C6.96289 11.1055 6.91016 10.9766 6.91016 10.8203C6.91016 10.6641 6.96289 10.5352 7.06836 10.4336C7.17383 10.3359 7.30469 10.2871 7.46094 10.2871H7.95312L10.0039 10.4043L8.375 8.86328L6.57031 7.05859C6.51562 7.00781 6.47461 6.94727 6.44727 6.87695C6.41992 6.80664 6.40625 6.73242 6.40625 6.6543C6.40625 6.49023 6.46094 6.35938 6.57031 6.26172C6.68359 6.16016 6.82227 6.10938 6.98633 6.10938C7.13867 6.10938 7.26367 6.16016 7.36133 6.26172L9.16016 8.07812L10.707 9.70117L10.584 7.65625V7.16406C10.584 7.00781 10.6348 6.87891 10.7363 6.77734C10.8379 6.67188 10.9648 6.61914 11.1172 6.61914C11.2734 6.61914 11.4023 6.67188 11.5039 6.77734C11.6094 6.88281 11.6621 7.01172 11.6621 7.16406V10.416C11.6621 10.7129 11.5781 10.9434 11.4102 11.1074C11.2461 11.2754 11.0137 11.3594 10.7129 11.3594H7.46094Z"/>
            </svg>
        </div>
    )
    
    const previewToolbar = previewDisplayType == "preview" ? (
        <PreviewToolbar>
            
            <PreviewToolbarIconGroup width={80} align={"flex-start"}>
                {previewFullscreenAction}
            </PreviewToolbarIconGroup>                    
            
            {stateOptionsMenu}

            <PreviewToolbarIconGroup width={80} align={"flex-end"}>
                {frameMenu}                           
            </PreviewToolbarIconGroup>

        </PreviewToolbar>
    ) : null

    const optionsContent =  showOptions ? (<PreviewOptionsContent>
                                                {displayOption}
                                            </PreviewOptionsContent>) : null    


        let rightContentStyle = {
            height: optionsBottom ? "calc(100vh - 130px)" : null
        }

    return (
        <PreviewContainer>  

            {/* {optionsBottom != true && optionsContent} */}

            <PreviewInnerContent className="inspector-right-content" style={rightContentStyle}>    
                {previewToolbar}
                {selectedItem && previewContent}
            </PreviewInnerContent>

            {optionsContent}
            {/* {optionsBottom  && optionsContent} */}

            <PreviewModal show={showPreviewModal} setShow={setShowPreviewModal} renderer={renderer} frameMenu={frameMenu} statesMenu={stateOptionsMenu} />

        </PreviewContainer>
    )
}

export function EditorViewActions({ editor }) {
    const { uiMode, setUIMode } = editor 

    const viewMenuIcon = (
        <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.64062 19.7344C3.77604 19.7344 3.11719 19.5104 2.66406 19.0625C2.21615 18.6198 1.99219 17.9714 1.99219 17.1172V7.625C1.99219 6.77083 2.21615 6.1224 2.66406 5.67969C3.11719 5.23177 3.77604 5.00781 4.64062 5.00781H17.9141C18.7786 5.00781 19.4349 5.23177 19.8828 5.67969C20.3307 6.1224 20.5547 6.77083 20.5547 7.625V17.1172C20.5547 17.9714 20.3307 18.6198 19.8828 19.0625C19.4349 19.5104 18.7786 19.7344 17.9141 19.7344H4.64062ZM4.78125 18H17.7656C18.1042 18 18.3646 17.9141 18.5469 17.7422C18.7292 17.5651 18.8203 17.2969 18.8203 16.9375V7.80469C18.8203 7.44531 18.7292 7.17969 18.5469 7.00781C18.3646 6.83073 18.1042 6.74219 17.7656 6.74219H4.78125C4.4375 6.74219 4.17448 6.83073 3.99219 7.00781C3.8151 7.17969 3.72656 7.44531 3.72656 7.80469V16.9375C3.72656 17.2969 3.8151 17.5651 3.99219 17.7422C4.17448 17.9141 4.4375 18 4.78125 18ZM12.5312 18.25V6.46094H14.1562V18.25H12.5312ZM15.7109 9.57031C15.5547 9.57031 15.4219 9.51562 15.3125 9.40625C15.2031 9.29688 15.1484 9.17188 15.1484 9.03125C15.1484 8.88542 15.2031 8.75781 15.3125 8.64844C15.4219 8.53906 15.5547 8.48438 15.7109 8.48438H17.2578C17.4141 8.48438 17.5469 8.53906 17.6562 8.64844C17.7656 8.75781 17.8203 8.88542 17.8203 9.03125C17.8203 9.17188 17.7656 9.29688 17.6562 9.40625C17.5469 9.51562 17.4141 9.57031 17.2578 9.57031H15.7109ZM15.7109 11.7188C15.5547 11.7188 15.4219 11.6641 15.3125 11.5547C15.2031 11.4453 15.1484 11.3177 15.1484 11.1719C15.1484 11.026 15.2031 10.901 15.3125 10.7969C15.4219 10.6875 15.5547 10.6328 15.7109 10.6328H17.2578C17.4141 10.6328 17.5469 10.6875 17.6562 10.7969C17.7656 10.901 17.8203 11.026 17.8203 11.1719C17.8203 11.3177 17.7656 11.4453 17.6562 11.5547C17.5469 11.6641 17.4141 11.7188 17.2578 11.7188H15.7109ZM15.7109 13.8594C15.5547 13.8594 15.4219 13.8073 15.3125 13.7031C15.2031 13.5938 15.1484 13.4661 15.1484 13.3203C15.1484 13.1745 15.2031 13.0495 15.3125 12.9453C15.4219 12.8359 15.5547 12.7812 15.7109 12.7812H17.2578C17.4141 12.7812 17.5469 12.8359 17.6562 12.9453C17.7656 13.0495 17.8203 13.1745 17.8203 13.3203C17.8203 13.4661 17.7656 13.5938 17.6562 13.7031C17.5469 13.8073 17.4141 13.8594 17.2578 13.8594H15.7109Z" fill="#374DC0"/>
        </svg>   
    )

    const toggleViewMode = () => {  
        if (uiMode == 'design-right') {
            setUIMode('view')
        } else {
            setUIMode('design-right')
        }
    }

    return <YapHeaderButton onClick={toggleViewMode}>{viewMenuIcon}</YapHeaderButton>
}

function FrameOptions({ frameIdenfifier, setItems, items, allItems, selectedId, defaultFrame }) {
    const [frameTypes, setFrameTypes] = useState([]);

    const currentFrameType = frameTypes.find((frame) => frame.id == frameIdenfifier)

    /**
     * Find any types that define a frame
     */
    useEffect(() => {
        let frameTypes = []
        allItems.filter(item => item.type == ItemType.yapui).forEach((item) => {
            if (item?.metadata?.previewFrame == true) {
                try {
                    frameTypes.push({ ...item, title: item.title, id: item.title, name: item.name })
                } catch (e) {
                    console.log('error', e)
                }
            }
        })

        setFrameTypes(frameTypes)
    }, [selectedId])

    const setFrame = (id, frame) => {   
        let newItems = items.map((item) => {
            if (item.path == id) {
                if (frame == defaultFrame.path) {
                    delete item.frame
                } else {
                    item.frame = frame
                }
            }
            return item
        })
        setItems(newItems)
    }

    const actionIcon = (
        <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="#b1b1b1" d="M3.16748 14.4648C2.40088 14.4648 1.82471 14.2744 1.43896 13.8936C1.05811 13.5176 0.867676 12.9512 0.867676 12.1943V3.25146C0.867676 2.49463 1.05811 1.92822 1.43896 1.55225C1.82471 1.17139 2.40088 0.980957 3.16748 0.980957H15.8384C16.6099 0.980957 17.186 1.17139 17.5669 1.55225C17.9478 1.92822 18.1382 2.49463 18.1382 3.25146V3.57373C17.9478 3.57373 17.7549 3.57373 17.5596 3.57373C17.3691 3.57373 17.1689 3.57373 16.959 3.57373V3.31006C16.959 2.9292 16.8589 2.64355 16.6587 2.45312C16.4634 2.25781 16.1851 2.16016 15.8237 2.16016H3.18213C2.81592 2.16016 2.53516 2.25781 2.33984 2.45312C2.14453 2.64355 2.04688 2.9292 2.04688 3.31006V12.1357C2.04688 12.5166 2.14453 12.8047 2.33984 13C2.53516 13.1904 2.81592 13.2856 3.18213 13.2856H12.5132C12.5181 13.3394 12.5229 13.3906 12.5278 13.4395C12.5327 13.4932 12.5376 13.5444 12.5425 13.5933C12.5669 13.7642 12.6084 13.9204 12.667 14.062C12.7305 14.2085 12.8062 14.3428 12.894 14.4648H3.16748ZM6.67578 12.7217C6.57324 12.7217 6.49023 12.6924 6.42676 12.6338C6.36328 12.5703 6.33154 12.4873 6.33154 12.3848C6.33154 12.2822 6.36328 12.1992 6.42676 12.1357C6.49023 12.0723 6.57324 12.0405 6.67578 12.0405H12.4839C12.4839 12.1528 12.4839 12.2676 12.4839 12.3848C12.4839 12.4971 12.4839 12.6094 12.4839 12.7217H6.67578ZM14.7617 14.4648C14.3076 14.4648 13.9561 14.3452 13.707 14.106C13.458 13.8667 13.3335 13.5298 13.3335 13.0952V5.80029C13.3335 5.36572 13.458 5.02881 13.707 4.78955C13.9561 4.54541 14.3076 4.42334 14.7617 4.42334H18.1016C18.5557 4.42334 18.9072 4.54541 19.1562 4.78955C19.4053 5.02881 19.5298 5.36572 19.5298 5.80029V13.0952C19.5298 13.5298 19.4053 13.8667 19.1562 14.106C18.9072 14.3452 18.5557 14.4648 18.1016 14.4648H14.7617ZM14.7837 13.5054H18.0796C18.2407 13.5054 18.3628 13.4614 18.4458 13.3735C18.5288 13.2905 18.5703 13.166 18.5703 13V5.89551C18.5703 5.72949 18.5288 5.60254 18.4458 5.51465C18.3628 5.42676 18.2407 5.38281 18.0796 5.38281H14.7837C14.6226 5.38281 14.5005 5.42676 14.4175 5.51465C14.3345 5.60254 14.293 5.72949 14.293 5.89551V13C14.293 13.166 14.3345 13.2905 14.4175 13.3735C14.5005 13.4614 14.6226 13.5054 14.7837 13.5054ZM15.4282 13.1318C15.2671 13.1318 15.1865 13.0464 15.1865 12.8755C15.1865 12.8071 15.2085 12.7485 15.2524 12.6997C15.2964 12.6509 15.355 12.6265 15.4282 12.6265H17.4204C17.4937 12.6265 17.5547 12.6509 17.6035 12.6997C17.6523 12.7485 17.6768 12.8071 17.6768 12.8755C17.6768 13.0464 17.5913 13.1318 17.4204 13.1318H15.4282ZM15.8457 6.43018C15.748 6.43018 15.6675 6.39844 15.604 6.33496C15.5405 6.2666 15.5088 6.18359 15.5088 6.08594C15.5088 5.99805 15.5405 5.92236 15.604 5.85889C15.6675 5.79053 15.748 5.75635 15.8457 5.75635H16.9956C17.0884 5.75635 17.1665 5.79053 17.23 5.85889C17.2983 5.92236 17.3325 5.99805 17.3325 6.08594C17.3325 6.18359 17.2983 6.2666 17.23 6.33496C17.1665 6.39844 17.0884 6.43018 16.9956 6.43018H15.8457Z" />
        </svg>
    )   

    const clearFrame = () => {
        setFrame(selectedId, null)
    }

    return (
        <YapContextMenu action={actionIcon}>
            <YapContextMenuOption title={"No Frame"} onClick={clearFrame} checked={frameIdenfifier == null} />
            <YapContextMenuDivider/>
            {/* <YapContextMenuHeader>{"Mobile"}</YapContextMenuHeader>  */}
            {frameTypes.map((frameType) => {
                let action = () => {
                    setFrame(selectedId, frameType.path)
                }
                let isDefault = frameType.path == defaultFrame?.path && frameIdenfifier == null
                return <YapContextMenuOption title={frameType.metadata?.name ?? frameType.name} onClick={action} checked={frameIdenfifier == frameType.path || isDefault} />
            })}        
        </YapContextMenu>
    )
}

/**
 * Adds default titles and other properties to preview states
 */
export function usePreviewStates(states) {
    if (states == null) {
        return []
    }   
    return states.map( (state, idx) => {    
        return { ...state,
                title: state.title ?? `Preview ${idx + 1}`,
        }
    })
}

function PreviewOptions({ previewStates, previewIndex, setPreviewIndex }) {
    let states = usePreviewStates(previewStates)

    if (states.length < 2) {    
        return null
    }
    let currentState = states[previewIndex ?? 0]
    if (currentState == null) {  return null }
    // const actionIcon = (
    //     <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    //         <path fill="#b1b1b1" d="M2.31543 6.3511C1.79134 6.3511 1.39714 6.2235 1.13281 5.96829C0.873047 5.70853 0.743164 5.31432 0.743164 4.78568V2.17435C0.743164 1.65026 0.873047 1.26061 1.13281 1.0054C1.39714 0.750193 1.79134 0.622589 2.31543 0.622589H13.9434C14.4674 0.622589 14.8594 0.750193 15.1191 1.0054C15.3835 1.26061 15.5156 1.65026 15.5156 2.17435V4.78568C15.5156 5.31432 15.3835 5.70853 15.1191 5.96829C14.8594 6.2235 14.4674 6.3511 13.9434 6.3511H2.31543ZM2.31543 13.2076C1.79134 13.2076 1.39714 13.0777 1.13281 12.8179C0.873047 12.5627 0.743164 12.173 0.743164 11.649V9.03079C0.743164 8.51126 0.873047 8.12389 1.13281 7.86868C1.39714 7.60892 1.79134 7.47903 2.31543 7.47903H13.9434C14.4674 7.47903 14.8594 7.60892 15.1191 7.86868C15.3835 8.12389 15.5156 8.51126 15.5156 9.03079V11.649C15.5156 12.173 15.3835 12.5627 15.1191 12.8179C14.8594 13.0777 14.4674 13.2076 13.9434 13.2076H2.31543Z" />
    //     </svg>
    // )   

    const chevron = (
        <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path  fill="#b1b1b1"  d="M6.68359 7.54837C6.51042 7.54837 6.35547 7.48229 6.21875 7.35013L0.927734 1.93607C0.86849 1.87682 0.822917 1.81074 0.791016 1.73782C0.759115 1.66035 0.743164 1.57832 0.743164 1.49173C0.743164 1.37324 0.770508 1.26614 0.825195 1.17044C0.879883 1.07474 0.952799 0.999542 1.04395 0.944855C1.13965 0.890167 1.24674 0.862823 1.36523 0.862823C1.53841 0.862823 1.68652 0.922068 1.80957 1.04056L7.0459 6.3931H6.31445L11.5508 1.04056C11.6784 0.922068 11.8265 0.862823 11.9951 0.862823C12.1136 0.862823 12.2184 0.890167 12.3096 0.944855C12.4053 0.999542 12.4805 1.07474 12.5352 1.17044C12.5898 1.26614 12.6172 1.37324 12.6172 1.49173C12.6172 1.66035 12.5557 1.80618 12.4326 1.92923L7.1416 7.35013C7.08236 7.41393 7.01172 7.46406 6.92969 7.50052C6.85221 7.53242 6.77018 7.54837 6.68359 7.54837Z" />
        </svg>
    )

    const action = (
        <span> 
            {currentState.title}&nbsp;{chevron}
        </span>
    )

    return (
        <YapContextMenu action={action}>
            {states.map((state, index) => {
                let action = () => {
                    setPreviewIndex(state.index)
                }
                return <YapContextMenuOption title={state.title} onClick={action} checked={index == (previewIndex ?? 0)}/>
            })}        
        </YapContextMenu>
    )
}

function PreviewModal({ show, setShow, renderer , frameMenu , statesMenu }) {
    return (
        <Modal contentLabel={"Preview"} ariaHideApp={false} className="modal modal-fullscreen" overlayClassName="modal-overlay" isOpen={show} onRequestClose={  () => {
            setShow(false)
        }}>
            <PreviewModalContent>
                <PreviewToolbar>
                    <div></div>
                    {statesMenu}
                    {frameMenu}
                </PreviewToolbar>
                {renderer}
            </PreviewModalContent>
        </Modal>
    )
}

const PreviewModalContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    height: 100%;
    width: 100%;
`

const PreviewInnerContent = styled.div`
    width: -webkit-fill-available;
`

const PreviewOptionsContent = styled.div`
    border-bottom: 1px solid #E3e3e3;
    width: -webkit-fill-available;
    align-items: center;
    justify-content: center;
    display: flex;
    height: 64px;
    & .polymer-segmented-control {
        min-width: 200px;
    }
`

const PreviewToolbarIconGroup = styled.div`
    display: flex;
    gap: 20px;
    justify-content: ${props => props.align ?? 'flex-start'};
    align-items: center;
    width: ${props => props.width}px;
`

const PreviewToolbar = styled.div`
    display: flex;
    width: -webkit-fill-available;
    position: absolute;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    font-size: 13px;
    font-weight: 500;
    color: #B1B1B1;
    z-index: 1;
    & .action {
        cursor: pointer;
    }
`

const PreviewContainer = styled.div`
    background-color: #fcfcfc;
    padding: 0px;
    width: -webkit-fill-available;
    display: flex;
    flex-direction: column;

    align-items: center;
    justify-content: top;


    & .control-segmented {
        border-bottom: 1px solid #E3e3e3;
        width: -webkit-fill-available;
        align-items: center;
        justify-content: center;
        inline-display: block;
        padding: 18px;
    }

    & .control-segmented-option {
        padding: 4px;
        cursor: pointer;
        display: block;
        width: 100px;
        justify-content: center;
        height: 20px;
        font-weight: 600;
        font-size: 14px;
        text-align: center;
    }
`
